import React, {useEffect, useState} from 'react';
import {useLanguage} from '@/contexts/LanguageContext.jsx';
import {logout} from '@/lib/auth/logout';
import supabase from '@/services/supabaseClient.js';

export default function ProductionCurrentUserAdmission({userId, children}) {
  const {languageCode} = useLanguage();
  const [result, setResult] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setResult({userId, status: 'checking'});
    async function check() {
      try {
        const {data, error} = await supabase.rpc('option_b_current_user_admitted');
        if (!cancelled) setResult({userId, status: !error && data === true ? 'admitted' : 'held'});
      } catch {
        if (!cancelled) setResult({userId, status: 'held'});
      }
    }
    check();
    return () => { cancelled = true; };
  }, [userId]);

  if (result?.userId === userId && result.status === 'admitted') return children;

  const fr = String(languageCode).startsWith('fr');
  const checking = result?.userId !== userId || result.status === 'checking';
  return <main className="min-h-[100dvh] grid place-items-center bg-background px-6 text-center">
    <section className="max-w-md space-y-4">
      <h1 className="text-title-large">{fr ? 'Accès AfriMed™' : 'AfriMed™ access'}</h1>
      <p role="status">{checking
        ? (fr ? 'Vérification de votre accès…' : 'Checking your access…')
        : (fr ? 'Votre accès ne peut pas encore être confirmé. Veuillez contacter l’assistance.' : 'Your access could not yet be confirmed. Please contact support.')}</p>
      {!checking && <button type="button" className="text-primary" onClick={() => logout({redirectTo:'/login?logout=1'})}>{fr ? 'Se déconnecter' : 'Sign out'}</button>}
    </section>
  </main>;
}
